import FoodoraMarketLogo from 'src/assets/groups/foodora-market/pink-logo.png'
import HokLogo from 'src/assets/groups/hok/S-KAUPAT_logo.png'
import RuokaboksiLogo from 'src/assets/groups/ruokaboksi/ruokaboksi-logo.png'
import { CompanyType } from 'src/types/types'

export const logos = {
  [CompanyType.Hok]: HokLogo,
  [CompanyType.FoodoraMarket]: FoodoraMarketLogo,
  [CompanyType.Ruokaboksi]: RuokaboksiLogo,
}

export const links = {
  [CompanyType.Hok]: 'https://www.s-kaupat.fi/',
  [CompanyType.FoodoraMarket]: 'https://www.foodora.fi',
  [CompanyType.Ruokaboksi]: 'https://ruokaboksi.fi',
}
